import styled from "styled-components";
import { MEDIA_QUERY } from "../../../entities/Common";
import { VIEW_TYPE } from "../../../entities/Filter";

export const CondimentWrapperStyled = styled.div`
  width: 100%;
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
  .condiment-wrapper {
    &__title {
      margin-bottom: 20px;
      padding-left: 0px;
      padding-right: 20px;
      box-sizing: border-box;
    }
    &__items {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
      grid-gap: 1rem;
      gap: 1rem;
      &[data-length="1"],
      &[data-length="2"],
      &[data-length="3"] {
        grid-template-columns: repeat(4, minmax(170px, 1fr));
      }
      &.view-${VIEW_TYPE.LIST} {
        display: block;
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    .condiment-wrapper {
      &__items {
        &[data-length="1"],
        &[data-length="2"],
        &[data-length="3"] {
          grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
        }
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    .condiment-wrapper {
      &__items {
        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        &[data-length="1"],
        &[data-length="2"],
        &[data-length="3"] {
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        }
      }
    }
  }
`;
